import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-afd23424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textarea" }
const _hoisted_2 = ["placeholder", "disabled", "readonly"]

import { Field } from 'vee-validate'

import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue?: number | string
  name?: string
  klass?: string
  rule?: string
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  nameAs?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleTextarea',
  props: {
    modelValue: null,
    name: { default: 'textarea' },
    klass: { default: 'default' },
    rule: null,
    placeholder: null,
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    nameAs: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number | string | undefined): void
  (e: 'change', value: number | string | undefined): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue?: number | string, name: string, klass: string, rule?: string, placeholder?: string, disabled: boolean, readonly: boolean, nameAs?: string };





const textareaValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', value)
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Field), {
      modelValue: _unref(textareaValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(textareaValue) ? (textareaValue).value = $event : null)),
      name: __props.name
    }, {
      default: _withCtx(({ field, errors }) => [
        _createElementVNode("textarea", _mergeProps(field, {
          name: "name",
          class: __props.klass,
          placeholder: __props.placeholder,
          disabled: __props.disabled,
          readonly: __props.readonly
        }), null, 16, _hoisted_2),
        (errors[0])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`error_${__props.klass}`)
            }, _toDisplayString(errors[0]), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "name"])
  ]))
}
}

})